<template>


  <div
      v-if="lot.auction_id != null && (lot.auction_status == 5 || lot.auction_status == 1 ||  lot.shop_price == 0 || lot.shop_price == null || ((lot.shop_price < lot.starting_price) && lot.custom_shop_price == null))"
      class="my-32">
    <div>
      <p class="flex justify-center text-gray-800 text-xl">
        {{ $t('lot.out_of_stock') }}
      </p>
      <div class="flex flex-wrap justify-center mt-5">
        <a class="btn-gray uppercase mr-5" :href="route('shop.landing') + '?anchor=highlights'"
           :data="{ anchor: 'highlights' }">
          {{ $t('menu.highlights') }}
        </a>
        <a class="btn-gray uppercase" :href="route('shop.landing') + '?anchor=categories'"
           :data="{ anchor: 'categories' }">
          {{ $t('menu.categories') }}
        </a>
      </div>
    </div>
  </div>
  <div v-else> <!-- -if="lot.shop_status !== 3" -->
    <div class="fixed-bottom bg-secondary text-white" v-if="canEditLots">
      <div class="container px-2 py-2">
        <div class="grid grid-cols-3" v-if="!loading">
          <div class="col-span-1">
            <div class="grid grid-cols-2">
              <img style="max-width:25px; filter:invert(1);"
                   class="xl:ml-24 lg:ml-24 md:ml-20 ml-12 mr-2 col-span-1" src="/assets/img/nova.png"/>
              <span class="hidden md:inline col-span-1">A10 Admin Bar</span>
            </div>
          </div>
          <div class="col-span-2">
            <ul class="list-unstyled">
              <li class="float-left mr-3" v-if="canEditLots">
                <a class="font-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/shop-lots/'+lot.id+'/edit'">Edit Lot</a>
              </li>
              <li class="float-left mr-3" v-if="canEditLots">
                <a class="font-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/shop-lots/'+lot.id">Lot Details</a>
              <li class="font-bold float-left mr-3 cursor-pointer"
                  v-if="canEditLots && confirm_sync===false && !syncing">
                                <span @click="confirm_sync=true"
                                      clss="font-bold text-white nounderline">Sync Lot</span>
              </li>
              <li class="float-left mr-3 cursor-pointer"
                  v-if="canEditLots && confirm_sync===true && !syncing">
                                <span @click="erpSync"
                                      class="font-bold text-warning nounderline">Confirm Lot Sync</span>
              </li>
              <li class="float-left mr-3 pr-3" style="background-color:#444; border-radius:10px;"
                  v-if="syncing">
                <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
                     height="20px"
                     viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                    <path fill="#fff"
                                          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg>
                <span class="font-bold text-white">Syncing</span>
              </li>

            </ul>

          </div>
        </div>
        <div class="loader center-vertically" v-if="loading">
          <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
               viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#fff"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
      </svg>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <div v-show="scrollPosition > 20" slot="header"
           class="z-50 fixed flex justify-center top-0 left-0 pt-20 pb-3 bg-white border-b w-full">
        <div class="max-w-a10 w-full px-5">
          <inertia-link :href="route('shop.category.view', lot.shop_category.slug)"
                        class="flex self-start items-center font-bold text-gray-700 hover:text-gray-900 transition ease-in-out duration-150">
            <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path d="M15 19l-7-7 7-7"></path>
            </svg>
            <span>{{ lot.shop_category.name }}</span>
          </inertia-link>
        </div>
      </div>
      <inertia-link :href="route('shop.category.view', lot.shop_category.slug)"
                    class="flex self-start items-center font-bold mb-12 text-gray-700 hover:text-gray-900 transition ease-in-out duration-150">
        <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
             viewBox="0 0 24 24" stroke="currentColor">
          <path d="M15 19l-7-7 7-7"></path>
        </svg>
        <span>{{ lot.shop_category.name }}</span>
      </inertia-link>
      <div class="flex flex-wrap max-w-6xl w-full mx-auto overflow-hidden">
        <div class="w-full flex justify-center text-3xl lg:w-1/2 px-4 lg:pr-6">
          <div class="lot-image-container max-w-full">
            <div class="main-image text-center" style="position:relative;">
              <figure class="lot-image" itemprop="associatedMedia" itemscope
                      @click.prevent="loadFullImages"
                      itemtype="http://schema.org/ImageObject">
                <a :href="img" class="thumbnail block" itemprop="contentUrl" data-size="1400x1403"
                   ref="main-href"
                   data-pswp-uid="lot-gallery-images" :aria-label="lot.title">
                  <img class="lot-image mx-auto" :src="img" itemprop="thumbnail"
                       :alt="`Image of ${lot.title}`">
                </a>
              </figure>
              <div v-if="lot.shop_status === 2" class="top-left soldB" style="">
                Sold
              </div>
            </div>

            <br/>
            <div class="more-images text-center relative">
              <div v-if="img_more && img_more.length > 3"
                   class="additional-images-lunchbox container mt-3 mb-5">
                <div class="swiper-container swiper-additional-images">
                  <div class="swiper-wrapper">
                    <div v-for="(item,key) in img_more" :key="key"
                         class="swiper-slide lot-additional-image">
                      <figure class="lot-image" itemprop="associatedMedia" itemscope
                              @click.prevent="loadFullImages"
                              itemtype="http://schema.org/ImageObject">
                        <a :href="item" class="thumbnail" itemprop="contentUrl"
                           data-size="1400x1403" :ref="'additional-href-'+key"
                           data-pswp-uid="lot-gallery-images" :aria-label="lot.title">
                          <img :alt="`Image of ${lot.title}`" class="lot-image" :src="item"
                               :id="'additional-image-'+key" :ref="'additional-image-'+key"
                               itemprop="thumbnail">
                        </a>
                        <figcaption itemprop="caption description" style="display:none;">
                          {{ img_more_labels[key] }}
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>

                <!-- Mobile Pagination -->
                <div class="flex lg:hidden justify-end mb-12">
                  <div class="swiper-pagination-additional-images"></div>
                </div>

                <div class="swiper-button-prev prev-additional-images hidden lg:block"></div>
                <div class="swiper-button-next next-additional-images hidden lg:block"></div>
              </div>

              <ul v-else-if="this.img_more" class="flex items-center justify-center">
                <li v-for="(item,key) in img_more" :key="key" class="lot-additional-image">
                  <figure class="lot-image img-fluid" itemprop="associatedMedia" itemscope
                          @click.prevent="loadFullImages"
                          itemtype="http://schema.org/ImageObject">
                    <a :href="item" class="thumbnail" itemprop="contentUrl" data-size="1400x1403"
                       :ref="'additional-href-'+key"
                       data-pswp-uid="lot-gallery-images">
                      <img class="lot-image img-fluid" :src="item" :id="'additional-image-'+key"
                           :ref="'additional-image-'+key" itemprop="thumbnail"
                           :alt="`Additional image of ${lot.title}`">
                    </a>
                    <figcaption itemprop="caption description" style="display:none;">
                      {{ img_more_labels[key] }}
                    </figcaption>
                  </figure>
                </li>
              </ul>
            </div>
            <div class="flex justify-center mt-2 mb-6">
              <dropdown class="self-center" placement="bottom-center" :overlay="false">
                <div class="flex items-center cursor-pointer select-none group">
                  <div
                      class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                    <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                         enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                         xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                            d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                  <a :href="lot.shop_facebook_share_link"
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                         width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                              <path
                                  d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                  data-original="#000000" class="active-path"/>
                            </svg>
                    <span class="pl-2">Facebook</span>
                  </a>
                  <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    <span class="pl-2">Email</span>
                  </a>
                  <div @click="copyToClipboard(lot)"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                    </svg>
                    <span class="pl-2">{{ $t('misc.copy_link') }}</span>
                  </div>
                </div>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="hidden lg:block lg:a10-w-1/10"></div>
        <div class="w-full lg:a10-w-4/10 px-4 lg:pl-6">
          <h1 v-if="lot.dating" class="a10-lot-title mb-2" v-html="makeLotTitle(lot)"></h1>
          <h1 v-else class="a10-lot-title mb-2" v-html="makeLotTitle(lot)"></h1>

          <div class="my-2" v-for="(artist, index) in lot.artists" :key="index">
            <div class="a10-lot-artist">
              <div class="grid grid-cols-2 gap-2">
                <div class="w-full">
                  <span class="row-artist" v-html="makeArtistLink(artist)"></span>
                  <span class="row-artist"
                        v-if="artist.type === 2 && lot.category_id !== 51 && lot.category_id !== 16 && lot.manufacturer">
                                  {{ lot.manufacturer }}
                                </span>
                </div>
                <div class="w-full">
                  <!--                          Urmareste Artist START-->
                  <div v-if="!isFollowed &&(lot.artists && lot.artists[0] && lot.artists[0].type === 1)"
                       id="follow-artist" @click="followArtist"
                       class="row" style="margin-left: 2.5rem;">
                    <svg enable-background="new 0 0 512 512" height="15" viewBox="0 0 512 512"
                         style="margin-top: 0.3rem;"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341
                                                  c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z
                                                  "/>
                      <path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318
                                                  c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83
                                                  s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/>
                    </svg>
                    <h6 style=" margin-left: 0.3rem; margin-top: 0.41rem;  font-weight: 700 !important; font-size: 0.8rem !important;">
                      {{ $t('lot.followArtistText') }}</h6>
                  </div>
                  <div v-if="isFollowed" id="unfollow-artist" @click="unfollowArtist"
                       class="row" style="margin-left: 1rem;">
                    <svg enable-background="new 0 0 512 512" height="15" viewBox="0 0 512 512"
                         style="margin-top: 0.3rem;"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933
                                              C477.726,107.033,370.834,0.141,238.933,0z M238.933,443.733c-113.108,0-204.8-91.692-204.8-204.8s91.692-204.8,204.8-204.8
                                              s204.8,91.692,204.8,204.8C443.611,351.991,351.991,443.611,238.933,443.733z"/>
                      <path d="M370.046,141.534c-6.614-6.388-17.099-6.388-23.712,0v0L187.733,300.134l-56.201-56.201
                                              c-6.548-6.78-17.353-6.967-24.132-0.419c-6.78,6.548-6.967,17.353-0.419,24.132c0.137,0.142,0.277,0.282,0.419,0.419
                                              l68.267,68.267c6.664,6.663,17.468,6.663,24.132,0l170.667-170.667C377.014,158.886,376.826,148.082,370.046,141.534z"/>
                    </svg>
                    <h6 style=" margin-left: 0.3rem; margin-top: 0.41rem; font-weight: 700 !important; font-size: 0.8rem !important;">
                      {{ $t('lot.artistFollowedText') }}</h6>
                  </div>
                  <!--                          Urmareste Artist END-->
                </div>
              </div>
            </div>
            <div class="w-100 ">
              <div class="iziToast-wrapper-artist"></div>
            </div>
            <div class="a10-lot-artist-description"
                 v-if="artist.birth_date && artist.birth_date != 0 && lot.category_id!==51">
                          <span v-if="artist.death_date && artist.death_date != 0">
                            {{ artist.birth_date }}<span v-if="artist.birth_place">, {{ artist.birth_place }}</span> -
                            {{ artist.death_date }}<span v-if="artist.death_place">, {{ artist.death_place }}</span>
                        </span>
              <span v-else>
                            <span
                                v-if="new Date().getFullYear()-artist.birth_date<=100">n.</span>{{ artist.birth_date }}, {{
                  artist.birth_place
                }}
                        </span>

            </div>
          </div>
          <div class="a10-lot-artist" v-if="!lot.artists && lot.old_artist">
            {{ lot.old_artist }}
          </div>
          <img
              v-if="((lot.auction_id == 860 && (lot.number  == 7 || lot.number  == 8 || lot.number  == 11 || lot.number  == 13 || lot.number  == 100 || lot.number  == 123 || lot.number  == 133 || lot.number  == 141 || lot.number  == 150 || lot.number  == 153 || lot.number  == 156 || lot.number  == 160 || lot.number  == 161 || lot.number  == 171 || lot.number  == 177 || lot.number  == 179 || lot.number  == 180 || lot.number  == 192 || lot.number  == 55 || lot.number  == 57)) || (lot.auction_id == 853 && (lot.number == 105 || lot.number == 153)))"
              style="float:right"
              src="/assets/img/Inima_caritabile.png"
              width="30px" height="30px"
          />
          <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
              src="/assets/img/icons/3-01.png" height="20" width="20"
              style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
          <br/>
          <hr class="my-4"/>

          <div v-if="lot.shop_status === 2" class="flex flex-col">
            <span class="a10-lot-description-title"> {{ $t('cart.sold_for') }}:</span>
            <span class="a10-lot-description-definition">&euro; {{ lot.formatted_shop_price }}</span>
          </div>

          <div v-else-if="lot.shop_status !== 2" class="flex flex-col">
                  <span v-if="lot.custom_shop_price && lot.shop_price_first_discount"><s>{{ $t('cart.sell_price') }}: &euro; {{
                      lot.formatted_shop_price
                    }}</s>
                  <br/>
                    <span v-if="lot.shop_price_first_discount"><s>{{
                        $t('cart.discount_sell_price')
                      }}: &euro; {{ lot.shop_price_first_discount }}</s></span>
                    <br/>
                    <span style="color:darkred"><b>{{ $t('cart.custom_sell_price') }}: &euro; {{
                        lot.custom_shop_price
                      }}</b></span>
                  </span>
            <span v-else-if="lot.shop_discount_price">
                    <span><s>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s></span>
                  <br/>
                    <span v-if="lot.shop_discount_price" style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
            <span v-else>
               <span class="a10-lot-description-title"> {{ $t('lot.price') }}</span>
  <span class="a10-lot-description-definition">&euro; {{ lot.formatted_shop_price }}</span>
            </span>
          </div>

          <hr class="my-4"/>

          <div class="flex flex-col" v-if="lot.list_price && lot.list_price > lot.shop_discount_price">
            <span class="a10-lot-description-title">{{ $t('misc.list_price') }}</span>
            <span class="a10-lot-description-definition">&euro; {{ lot.list_price }}</span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col" v-if="lot.warranty">
            <span class="a10-lot-description-title">{{ $t('misc.warranty') }}</span>
            <span class="a10-lot-description-definition">{{ lot.warranty }}</span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col"
               v-if="(lot.material_carats || lot.weight || lot.width || lot.height || lot.depth ||lot.dimensions || lot.signature) &&
               ((lot.category_id !== 51) || (lot.material_carats && (lot.category_id === 13 || lot.category_id === 14)) || (lot.weight && (lot.category_id === 13 || lot.category_id === 14)) || (lot.width && lot.height && lot.depth && lot.category_id !== 51) || (lot.category_id !== 51 && lot.width && lot.height) || (lot.category_id !== 51 && lot.dimensions) || (lot.category_id !==51 && lot.signature))">
            <span class="a10-lot-description-title">{{ $t('misc.description') }}</span>

            <div class="a10-lot-description-definition">
                        <span v-if="lot.category_id !== 51 && lot.medium">{{ lot.medium }}<span v-if="(lot.material_carats && (lot.category_id===13 || lot.category_id===14)) ||
(lot.weight && (lot.category_id===13 || lot.category_id===14)) ||
(lot.width && lot.height && lot.depth && lot.category_id!==51) ||
(lot.category_id!==51 && lot.width && lot.height && lot.depth && lot.weight) ||
(lot.category_id!==51 && lot.width && lot.height) ||
(lot.category_id!==51 && lot.dimensions) ||
(lot.category_id!==51 && lot.signature)
">, </span>
                        </span>
              <span v-if="lot.material_carats && (lot.category_id===13 || lot.category_id===14)">
                        {{ lot.material_carats }}
                        </span>
              <span v-if="lot.weight && (lot.category_id===13 || lot.category_id===14)">
                        {{ lot.weight }}
                        </span>
              <span v-if="lot.width && lot.height && lot.depth && lot.category_id!==51">
                        {{ lot.height }} &times; {{ lot.width }} &times; {{ lot.depth }} cm
                        </span>
              <span v-else-if="lot.category_id!==51 && lot.width && lot.height && lot.depth && lot.weight">
                        {{ lot.height }} &times; {{ lot.width }} cm,
                        </span>
              <span v-else-if="lot.category_id!==51 && lot.width && lot.height">
                        {{ lot.height }} &times; {{ lot.width }} cm
                        </span>
              <span v-else-if="lot.category_id!==51 && lot.dimensions">
                        {{ lot.dimensions }}
                        </span>
              <span v-if="lot.category_id!==51 && lot.signature">
                        {{ lot.signature }}
                        </span>
              <br>
              <span
                  v-if="((lot.auction_id == 860 && (lot.number  == 7 || lot.number  == 8 || lot.number  == 11 || lot.number  == 13 || lot.number  == 100 || lot.number  == 123 || lot.number  == 133 || lot.number  == 141 || lot.number  == 150 || lot.number  == 153 || lot.number  == 156 || lot.number  == 160 || lot.number  == 161 || lot.number  == 171 || lot.number  == 177 || lot.number  == 179 || lot.number  == 180 || lot.number  == 192 || lot.number  == 55 || lot.number  == 57)) || (lot.auction_id == 853 && (lot.number == 105 || lot.number == 153)))">
                            {{ $t('lot.caritable_description') }}
                          </span>
            </div>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col" v-if="lot.provenance">
            <span class="a10-lot-description-title">{{ $t('misc.provenance') }}</span>
            <span class="a10-lot-description-definition">{{ lot.provenance }}</span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col" v-if="lot.research_info">
            <span class="a10-lot-description-title">{{ $t('misc.research_info') }}</span>
            <span class="a10-lot-description-definition">{{ lot.research_info }}</span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col" v-if="lot.notes">
            <span class="a10-lot-description-title">{{ $t('misc.verso') }}</span>
            <span class="a10-lot-description-definition">{{ lot.notes }}</span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col a10-lot-description-definition" v-if="lot.description">
            <span class="a10-lot-description-title">{{ $t('misc.details') }}</span>

            <div v-if="lot.description.length < 700" v-html="lot.description"></div>
            <div v-else class="description">
              <span v-html="description.content"></span>
              <button class="toggle-more" @click="toggleMore()">
                <span v-if="description.more">Read more</span>
                <span v-else>Read less</span>
              </button>
            </div>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col" v-if="lot.bio && lot.category_id!==51">
            <span class="a10-lot-description-title">Bibliografie</span>
            <span class="a10-lot-description-definition" v-html="lot.bio"></span>

            <hr class="my-4"/>
          </div>

          <div class="flex flex-col">
            <span class="a10-lot-description-title">{{ $t('lot.more_info') }}</span>
            <span class="a10-lot-description-definition text-xs" v-html="$t('lot.condition')"></span>
            <span class="a10-lot-description-definition text-xs">
                      <a class="h7"
                         :href="'mailto:infoconservare@artmark.ro?subject=Cerere informații despre starea de conservare a produsului din DDA  - ' + lot.title + '&body=' + lot.title + ' - ' + currentPage()">
                        <u>{{ $t('lot.here') }}.</u>
                      </a>
                    </span>
            <span class="a10-lot-description-definition text-xs">
                           <a style="text-decoration: underline" class="h7"
                              :href="route('shop.howbuy.view')">
                                {{ $t('menu.how_buy') }}.
                      </a>
                    </span>
            <span class="a10-lot-description-definition text-xs" v-html="$t('lot.info')"></span>

          </div>

          <div class="flex flex-col mt-8">
            <div :id="'addToCart_wrapper_' + lot.id">
              <a v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                 class="btn-gray mt-3 uppercase font-bold text-sm a10-btn-padding addToCart">
                {{ $t('cart.add_cart') }}
              </a>
              <a v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                 :href="route('shop.cart.view')"
                 class="btn-gray mt-3 uppercase font-bold text-sm a10-btn-padding addToCartDisabled">
                <span v-html="$t('cart.added_cart')"></span></a>
              <a v-else-if="lot.shop_status == 1 || lot.shop_status == 3"
                 href="" @click="askDetails()" id="askDetail"
                 class="btn-gray mt-3 uppercase font-bold text-sm a10-btn-padding addToCart">
                <span v-html="$t('cart.ask_details')"></span></a>
              <div class="iziToast-ask-details" id="iziToast-ask-details"></div>
            </div>
            <span v-if="visits" class="text-xs text-gray-700 mt-2">
                      <span class="font-bold">{{ visits }}</span>
                      <span v-if="visits < 2">{{ $t('misc.one_client') }}</span>
                      <span v-else>{{ $t('misc.one_client') }} </span>{{ $t('misc.visited') }}
                    </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap max-w-6xl w-full mx-auto overflow-hidden">
        <h2 class="text-2xl text-gray-900 mb-8 mt-4 mt-lg-0 border-b self-start">{{
            $t('misc.related')
          }}</h2>
      </div>
      <div class="flex flex-wrap max-w-6xl w-full mx-auto overflow-hidden">
        <div v-for="(lot, index) in relatedLots" :key="index" class="p-3 w-full md:w-1/2 lg:w-1/3 group">
          <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)"><img
              class="transform group-hover:scale-105 transition ease-in-out duration-150"
              :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/></inertia-link>
          <div class="pt-6 flex justify-between items-start">
            <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150">
              {{ makeLotTitle(lot, true) }}</h2></inertia-link>
            <div :id="'addToCart_wrapper_' + lot.id">
              <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                      class="btn-gray ">{{ $t('cart.add_cart') }}
              </button>
              <a :href="route('shop.cart.view')"
                 v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                 class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
            </div>
          </div>
          <div class="flex justify-between items-center pt-3">
            <div>
              <h4 class="a10-lot-listing-author">
                          <span v-for="(artist,index) in lot.artists" :key="index">
                              <span v-if="artist.firstname">{{ artist.firstname }} {{ artist.lastname }}</span><span
                              v-else>{{ artist.name }}</span><span v-if="index != lot.artists.length - 1">, </span>
                          </span>
                <div v-if="!lot.artists && lot.old_artist">
                  {{ lot.old_artist }}
                </div>
              </h4>
              <div v-if="lot.shop_status === 2" class="flex flex-col">
                <span class="a10-lot-description-title"> {{ $t('cart.sold_for') }}:</span>
                <span class="a10-lot-description-definition">&euro; {{ lot.formatted_shop_price }}</span>
              </div>

              <div v-else-if="lot.shop_status !== 2" class="flex flex-col">
                  <span v-if="lot.custom_shop_price && lot.shop_price_first_discount"><s>{{ $t('cart.sell_price') }}: &euro; {{
                      lot.formatted_shop_price
                    }}</s>
                  <br/>
                    <span v-if="lot.shop_price_first_discount"><s>{{
                        $t('cart.discount_sell_price')
                      }}: &euro; {{ lot.shop_price_first_discount }}</s></span>
                    <br/>
                    <span style="color:darkred"><b>{{ $t('cart.custom_sell_price') }}: &euro; {{
                        lot.custom_shop_price
                      }}</b></span>
                  </span>
                <span v-else-if="lot.shop_discount_price">
                    <span><s>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s></span>
                  <br/>
                    <span v-if="lot.shop_discount_price" style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                <span v-else>
               <span class="a10-lot-description-title"> {{ $t('lot.price') }}</span>
  <span class="a10-lot-description-definition">&euro; {{ lot.formatted_shop_price }}</span>
            </span>
              </div>

            </div>
            <div class="favShare">
              <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                  src="/assets/img/icons/3-01.png" height="20" width="20"
                  style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
              <dropdown placement="bottom-center" :overlay="false">
                <div class="flex items-center cursor-pointer select-none group">
                  <div
                      class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                    <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                         enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                         xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                            d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                  <a :href="lot.shop_facebook_share_link"
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                         width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                    <span class="pl-2">Facebook</span>
                  </a>
                  <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    <span class="pl-2">Email</span>
                  </a>
                  <div @click="copyToClipboard(lot)"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                    </svg>
                    <span class="pl-2">Copiază link-ul</span>
                  </div>
                </div>
              </dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="pswp__bg"></div>
        <div class="pswp__scroll-wrap">
          <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
          </div>
          <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
              <div class="pswp__counter"></div>
              <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
              <button class="pswp__button pswp__button--share" title="Share"></button>
              <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
              <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>
            <div class="pswp__caption">
              <div class="pswp__caption__center"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <div v-else-if="lot.shop_status === 3" class="my-32">-->
  <!--    <div>-->
  <!--      <p class="flex justify-center text-gray-800 text-xl">-->
  <!--        {{ $t('lot.out_of_stock') }}-->
  <!--      </p>-->
  <!--      <div class="flex flex-wrap justify-center mt-5">-->
  <!--        <a class="btn-gray uppercase mr-5" :href="route('shop.landing') + '?anchor=highlights'"-->
  <!--           :data="{ anchor: 'highlights' }">-->
  <!--          {{ $t('menu.highlights') }}-->
  <!--        </a>-->
  <!--        <a class="btn-gray uppercase" :href="route('shop.landing') + '?anchor=categories'"-->
  <!--           :data="{ anchor: 'categories' }">-->
  <!--          {{ $t('menu.categories') }}-->
  <!--        </a>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>
<style scoped>
.addToCart {
  cursor: pointer;
}

.addToCartDisabled {
  background: #48bb78 !important;
  cursor: pointer;
}

#addToCart_wrapper a {
  cursor: pointer !important;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}

.text-warning {
  color: #ffa260 !important
}

#follow-artist, #unfollow-artist {
  cursor: pointer;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
}

.soldB {
  margin: 0px auto;
  text-align: center;
  width: 65px;
  background-color: black;
  height: 65px;
  line-height: 65px;
  border-radius: 50%;
  font-size: 14px;
  color: rgb(255, 255, 255);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.iziToast-target {
  right: initial !important;
}
</style>
<script>
import Layout from '@/Shared/Layout'
import Swiper from 'swiper'
import Dropdown from '@/Shared/Dropdown'
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: this.lot.title,
      meta: [
        {
          name: 'robots',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {
          name: 'googlebot',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {name: 'title', content: this.lot.meta_info_title},
        {name: 'description', content: this.lot.meta_info_description},
        {name: 'keywords', content: this.lot.meta_info_keywords},
        // Facebook
        {name: 'og:title', property: 'og:title', content: this.lot.meta_info_title},
        {name: 'og:description', property: 'og:description', content: this.lot.meta_info_description},
        {name: 'og:image', property: 'og:image', content: this.lot.meta_info_image},
        {name: 'og:url', property: 'og:url', content: window.location.href},
        {name: 'og:type', property: 'og:type', content: 'website'},
      ]
    }
  },
  layout: Layout,
  props: {
    lot: Object,
    relatedLots: Array,
    visits: Number,
    canEditLots: Boolean,
    auction_external_id: String,
    logged_in: String
  },
  components: {
    Layout,
    Dropdown
  },
  data() {
    return {
      more: false,
      updatedCount: 0,
      loadedFullImages: false,
      scrollPosition: null,
      loading: false,
      confirm_sync: false,
      syncing: false,
      isFollowed: null,
    }
  },
  methods: {
    locale: function (artists) {
      return window.location.pathname.split('/')[1];
    },
    makeArtistLink: function (artist) {
      if (artist.has_page) {
        return '<a href="/' + this.locale() + '/artist/' + artist.slug + '" style="text-decoration: underline">' + artist.name + '</a>';
      } else {
        return artist.name
      }
    },
    makeLotTitle: function (lot, short = false) {
      let newArguments = [];
      let title = lot.title;
      if (short) {
        title = lot.shortened_title;
      }

      if (lot.heritage === 1) {
        newArguments.push('C');
      }
      if (lot.heritage === 2) {
        newArguments.push('F');
      }
      if (lot.heritage === 3) {
        newArguments.push('T');
      }
      if (lot.heritage === 4) {
        newArguments.push('IC');
      }
      if (lot.heritage === 5) {
        newArguments.push('IT');
      }
      if (lot.archive_preemption === 1) {
        newArguments.push('A');
      }
//return $dating ? $return . " [$dating]" : $return;
      if (newArguments.length > 0) {
        return lot.dating ? '<sup>' + newArguments.join(", ") + '</sup> ' + title + '[' + lot.dating + ']' : '<sup>' + newArguments.join(", ") + '</sup> ' + title;
      } else {
        return lot.dating ? title + '[' + lot.dating + ']' : title;
      }
    },
    askDetailsDiscount: function () {
      if (this.logged_in != null) {
        event.preventDefault();
        axios({
          method: "post",
          url: "/api/ask-details",
          data: {"type": "askDetailsDDADiscount", "params": {"lot": this.lot.id, "user": this.logged_in}},
          config: {
            headers: {
              "Content-Type": "application/json",
            }
          }
        }).then((response) => {
          if (response.status == 200) {
            let msg = 'Echipa DDA a fost anuntata, veti fi contactat in cel mai scurt timp!';
            this.$iziToast.show({
              message: msg,
              color: 'green',
              // position: 'bottomRight',
              target: ".iziToast-ask-details",
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          } else {
            let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
            this.$iziToast.show({
              message: msg,
              color: 'red',
              // position: 'bottomRight',
              target: ".iziToast-ask-details",
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          }
        }).catch(function (error) {
          let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
          this.$iziToast.show({
            message: msg,
            color: 'red',
            // position: 'bottomRight',
            target: ".iziToast-ask-details",
            progressBar: false,
            timeout: 50000,
            displayMode: 'once'
          });
        });
      } else {
        window.location.href = "mailto:office@dependentdearta.ro?subject=Informatii despre lot id: " + this.lot.id + "&body=Buna ziua, " + "%0D%0A" + "%0D%0A" +
            "As dori să îmi furnizați informații despre reducerea suplimentară aferentă acestui produs." + "%0D%0A" +
            "Link catre produs: " + window.location.href + "%0D%0A" + "%0D%0A" +
            "Va multumesc,"
      }
    },
    askDetails: function () {
      if (this.logged_in != null) {
        event.preventDefault();
        axios({
          method: "post",
          url: "/api/ask-details",
          data: {"type": "askDetailsDDA", "params": {"lot": this.lot.id, "user": this.logged_in}},
          config: {
            headers: {
              "Content-Type": "application/json",
            }
          }
        }).then((response) => {
          if (response.status == 200) {
            let msg = 'Echipa DDA a fost anuntata, veti fi contactat in cel mai scurt timp!';
            this.$iziToast.show({
              message: msg,
              color: 'green',
              // position: 'bottomRight',
              target: ".iziToast-ask-details",
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          } else {
            let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
            this.$iziToast.show({
              message: msg,
              color: 'red',
              // position: 'bottomRight',
              target: ".iziToast-ask-details",
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          }
        }).catch(function (error) {
          let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
          this.$iziToast.show({
            message: msg,
            color: 'red',
            // position: 'bottomRight',
            target: ".iziToast-ask-details",
            progressBar: false,
            timeout: 50000,
            displayMode: 'once'
          });
        });
      } else {
        window.location.href = "mailto:dda@artmark.ro?subject=Informatii despre lot id: " + this.lot.id + "&body=Buna ziua, " + "%0D%0A" + "%0D%0A" +
            "As dori mai multe informatii despre lotul numarul: " + this.lot.id + ", " + "%0D%0A" +
            "Titlu lot: " + this.lot.title.toString() + "%0D%0A" +
            "Link catre lot: " + window.location.href + "%0D%0A" + "%0D%0A" +
            "Va multumesc,"
      }
    },
    followArtist: function (event) {
      if (this.is_logged_in) {
        event.stopPropagation();
        this.type = 'artist';

        if (this.isFollowed) {
          var msgErr = 'Artist deja adăugat!';
          window.showToast(
              msgErr,
              "error",
              null,
              ".iziToast-wrapper-artist"
          );
        } else {
          axios({
            method: "post",
            url: "/api/add-favorites",
            data: {"favorites": [{"type": this.type, "id": this.lot.artists[0].id}]},
            config: {
              headers: {
                "Content-Type": "application/json",
              }
            }
          }).then((response) => {
            this.isFollowed = true;
            let msg = 'Artist adăugat. Vezi artiștii urmăriți în secțiunea Favorite din contul tău.';
            this.$iziToast.show({
              message: msg,
              color: 'green',
              position: null,
              target: ".iziToast-wrapper-artist",
              progressBar: false,
              timeout: 5000,
              displayMode: 'once'
            });
          }).catch(function (error) {
            if (error.status === 401) {
              this.$iziToast.show({
                message: error.data.message,
                color: 'red',
                position: null,
                target: ".iziToast-wrapper-artist",
                progressBar: false,
                timeout: 5000,
                displayMode: 'once'
              });
            }
          });
        }
      } else {
        let localFavorites = localStorage.getItem('localFavorites');

        localFavorites = localFavorites ? localFavorites.split(',') : [];
        localFavorites.push(JSON.stringify({
          type: 'artist',
          fav_id: this.lot.artists[0].id,
          whereFrom: location.href
        }));

        localStorage.setItem('localFavorites', localFavorites);
        window.location.replace('/ro/autentificare')
      }
      event.preventDefault();
    },
    unfollowArtist: function (event) {
      document.activeElement.blur();
      event.stopPropagation();
      this.type = 'artist';
      axios({
        method: "post",
        url: "/api/remove-favorites",
        data: {"favorites": [{"type": this.type, "id": this.lot.artists[0].id}]},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then((response) => {
        this.isFollowed = false;
        var msg = 'Artist eliminat!';
        // $('#showMessage').text(msg);
        // $('#showMessage').delay(2000).fadeOut('slow', function () {
        //     $('#showMessage').show();
        //     $('#showMessage').text('');
        // });
      }).catch(function (error) {
        if (error.response.status === 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-modal"
          );
        } else {
          location.reload();
        }
      });
      event.preventDefault();
    },
    toggleMore() {
      this.more = !this.more
    },
    inArray(needle) {
      var haystack = Object.keys(this.$page.cart.items);
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    addToCart(id) {
      let locale = this.locale();
      axios({
        method: "post",
        url: '/' + locale + '/cart/add/' + id
      }).then((response) => {
        if (response.data.status == 'success') {
          let carts = document.querySelectorAll('sup.cart_quantity');
          for (let i = 0, len = carts.length; i < len; ++i) {
            let cart = carts[i];
            cart.innerHTML = response.data.quantity;
          }
          if (locale != 'ro') {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/en/cart'  style='background: #48bb78;' class=\"btn-gray mt-3 uppercase font-bold text-sm a10-btn-padding addToCartDisabled\">Product added! Go to your cart!</a>";
          } else {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/ro/cart'  style='background: #48bb78;' class=\"btn-gray mt-3 uppercase font-bold text-sm a10-btn-padding addToCartDisabled\">Produs adăugat! Vezi coșul!</a>";
          }
        } else {
          this.$iziToast.show({
            message: response.data.message,
            color: 'red',
            position: null,
            target: "#iziToast-wrapper_cart_" + id,
            progressBar: false,
            timeout: 5000000000000000,
            displayMode: 'replace'//once
          });
        }
      });
    },
    loadFullImages: function () {
      if (!this.loadedFullImages) {
        this.loadedFullImages = true;
        this.$refs['main-href'].href = this.img_full;
        if (this.img_more_full) {
          for (var i = 0; i < this.img_more_full.length; i++) {
            this.$refs['additional-href-' + i][0].href = this.img_more_full[i];
          }
        }
      }
    },
    currentPage() {
      return window.location.href
    },
    copyToClipboard(lot) {
      return window.navigator.clipboard.writeText(this.route('shop.lot.view', lot.slug));
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    erpSync: function () {
      let bodyFormData = new FormData();
      bodyFormData.set("external_id", this.auction_external_id);
      bodyFormData.set("lot_number", this.auction_external_id == 'no_auction' ? this.lot.origin_id : this.lot.number);
      bodyFormData.set("sync_action", "sync-lot");
      bodyFormData.set("auction_domain", 'ro');
      this.syncing = true;

      if(this.auction_external_id == 'no_auction'){
        let that = this;
        axios({
          method: "get",
          url: "/api/erpsync/dda/dda-import/" + that.lot.origin_id,
          data: bodyFormData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        })
            .then(response => {
              (that.syncing = false),
                  (that.confirm_sync = false),
                  this.$iziToast.show({
                    message: response.data.message,
                    color: 'green',
                    position: 'bottomRight',
                    progressBar: false,
                    timeout: 5000,
                    displayMode: 'once'
                  });
            })
            .catch(error => {
              (that.syncing = false),
                  (that.confirm_sync = false),
                  this.$iziToast.show({
                    message: error.response.data.message,
                    color: 'red',
                    position: 'bottomRight',
                    progressBar: false,
                    timeout: 5000,
                    displayMode: 'once'
                  });
            })
      }else{
        let that = this;
        //   this.$inertia.post(this.route('api.erp-sync', bodyFormData))
        axios({
          method: "post",
          url: "/api/erp-sync",
          data: bodyFormData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        })
            .then(response => {
              (that.syncing = false),
                  (that.confirm_sync = false),
                  this.$iziToast.show({
                    message: response.data.message,
                    color: 'green',
                    position: 'bottomRight',
                    progressBar: false,
                    timeout: 5000,
                    displayMode: 'once'
                  });
            })
            .catch(error => {
              (that.syncing = false),
                  (that.confirm_sync = false),
                  this.$iziToast.show({
                    message: error.response.data.message,
                    color: 'red',
                    position: 'bottomRight',
                    progressBar: false,
                    timeout: 5000,
                    displayMode: 'once'
                  });
            });
      }


    },
  },
  computed: {
    description() {
      let n = 700
      if (this.lot.description.length <= n || this.more) {
        return {
          content: this.lot.description,
          more: false
        }
      }
      var subString = this.lot.description.substr(0, n - 1)
      return {
        content: subString.substr(0, subString.lastIndexOf(' ')) + '&hellip;',
        more: true
      }
    },
    img: function () {
      return this.lot.details_image;
    },
    is_logged_in: function () {
      return this.logged_in;
    },
    img_full: function () {
      return this.lot.main_image;
    },
    img_more: function () {
      return this.lot.additional_image_thumbnails;
    },
    img_more_full: function () {
      return this.lot.additional_images;
    },
    img_more_labels: function () {
      return this.lot.additional_image_labels;
    },
  },
  mounted() {
    this.loading = true;
    window.addEventListener('scroll', this.updateScroll);

    initPhotoSwipeFromDOM('.lot-image-container figure');
    if (this.is_logged_in && this.lot && this.lot.artists.length && this.lot.artists[0].id) {
      axios({
        method: "get",
        url: "/api/check-favorites",
        params: {type: 'artist', id: this.lot.artists[0].id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.isFollowed = response.data.isFav;
      }).catch(error => {
        if (error.response.status !== 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-artist"
          );
        } else {
          location.reload();
        }
      });
    }

    if (this.img_more && this.img_more.length > 3) {
      var swiper_additional_images = new Swiper('.swiper-additional-images', {
        centeredSlide: true,
        loop: false,
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        // If we need pagination
        pagination: {
          el: '.swiper-pagination-additional-images',
          paginationClickable: true,
          type: 'bullets',
          bulletElement: 'span',
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.next-additional-images',
          prevEl: '.prev-additional-images',
        },
      });
    }
    this.loading = false;
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  }
}
</script>
